// extracted by mini-css-extract-plugin
export default {"container":"MetadataContainer-module__container--nU0s9"};